/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Naam_VoorbeeldInputs */

const nl_planning_vakanties_naam_voorbeeld = /** @type {(inputs: Planning_Vakanties_Naam_VoorbeeldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Studiedag`)
};

/**

* @param {Planning_Vakanties_Naam_VoorbeeldInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_naam_voorbeeld = /** @type {((inputs?: Planning_Vakanties_Naam_VoorbeeldInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Naam_VoorbeeldInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_naam_voorbeeld(inputs)
});
export { planning_vakanties_naam_voorbeeld as "planning.vakanties.naam_voorbeeld" }